module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Esdras")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Josiah (1:1–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:23–24")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:25–32")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:33")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Kings of Judah (1:34–58)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Restoration under Cyrus (2:1–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opposition to the Rebuilding (2:16–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:17")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of the Three Bodyguards (3:1–5:3)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:1–3 and 4:42–5:3")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:4–4:32")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:33–5:3")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A List of the Returning Exiles (5:4–46)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:40")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Restoration of Worship (5:47–55)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:50")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rebuilding of the Temple (5:56–73)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:73")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Completion and Dedication of the Temple (6:1–7:15)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:1–22")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:23–34")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:1–9")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:10–15")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ministry of Ezra (8:1–9:55)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch1-s28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:37–55")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Esdras")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch2-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch2-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Ezra = 2 Esdras 1–2")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction and Call to Prophesy (1:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Guilt of Israel’s Nonresponse (1:12–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Nation to Replace the Old (1:35–2:14)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New People as a Woman (2:15–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New People Will Be Composed of Gentiles (2:33–48)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Ezra = 2 Esdras 3–14")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Episode (3:1–5:19)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Episode (5:20–6:34)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Third Episode (6:35–9:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fourth Episode (9:26–10:59)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fifth Episode (11:1–12:39)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sixth Episode (13:1–58)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Seventh Episode (14:1–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch2-s17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Ezra = 2 Esdras 15–16")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Punishment That Is Due (15:1–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Specific Threats (15:28–63)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Individual Warnings (16:1–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warnings to God’s People (16:35–67)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b",
    attrs: {
      "id": "ch2-s22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch2-s22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reward for the Faithful (16:68–78)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2b",
    attrs: {
      "id": "back"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/back#back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get the Complete Commentary!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0